import {Select as AntSelect} from 'antd'
import styled from 'styled-components'

export const Component = styled.div`
  display: flex;
  gap: 8px;
`
export const Select: StyledOverride<typeof AntSelect> = styled(AntSelect)`
  & .ant-select-selection-item {
    min-width: 38px;
  }
`
